import React, { useEffect, useState } from 'react';
import { TextField } from '../textField/TextField';
import PrimaryLoader from '../primaryLoader/PrimaryLoader';
import { useEmailValidation } from '../../../utils/useEmailValidation';
import Tick from '../icons/Tick';

import styles from './EmailField.module.scss';
import clsx from 'clsx';

const EmailField = (
  {
    className,
    name,
    defaultValue,
    register,
    setError,
    setValue,
    setEmailIsReady,
    hasEmailValidationCode = true,
    error,
    customClasses,
    isPureField,
    ...rest
  },
) => {
  const [emailValue, setEmailValue] = useState(defaultValue);

  const {
    requestKey,
    projectConfig,
    isEmailValidationLoading,
    setIsEmailValidationLoading,
    emailStatus,
    setEmailStatus,
    warningMessage,
    handleEmailValidation,
  } = useEmailValidation();

  const handleValidation = () => {
    const ignoreValidation = window?.localStorage.getItem('ignoreEmailValidation');

    if (ignoreValidation || !requestKey) {
      setEmailIsReady(true);
      setIsEmailValidationLoading(false);
      return true;
    }

    return new Promise((resolve) => {
      handleEmailValidation(
        {
          email: emailValue || defaultValue,
          requestKey,
          projectConfig,
          setValidate: setIsEmailValidationLoading,
          resolve,
          setEmailStatus,
          setFormError: (message) => {
            setError(name, { message });
            setEmailIsReady(false);
          },
          setInputResult: (result) => {
            if (!result?.StatusCode) return;
            setValue('email_validation_code', result.StatusCode);
            setValue('email_validation_response', JSON.stringify(result));
            setEmailIsReady(result.StatusCode && result.StatusCode !== '2');
          },
        }
      );
    });
  };

  const handleValidationOnBlur = async (event) => {
    if (!event?.target?.value || isEmailValidationLoading) return;
    await handleValidation()
  };

  useEffect(() => {
    if ((!hasEmailValidationCode || defaultValue) && requestKey) {
      handleValidation();
    }
  }, [hasEmailValidationCode, defaultValue, requestKey]);

  return (
    <>
      <input type="hidden" {...register("email_validation_code")} />
      <input type="hidden" {...register("email_validation_response")} />
      <TextField
        type="email"
        inputMode="email"
        maxLength={250}
        defaultValue={defaultValue}
        className={clsx(className, styles.emailField)}
        customClasses={{
          ...customClasses,
          warning: styles.warningMessage,
        }}
        {...register(name, {
          onBlur: handleValidationOnBlur,
          onChange: (e) => {
            setEmailIsReady(false);
            setEmailValue(e.target.value);
            setEmailStatus(null);
          },
        })}
        onFocusOut={handleValidationOnBlur}
        warning={emailStatus === '1' || emailStatus === '3'}
        warningMessage={!isPureField && warningMessage}
        error={error}
        iconAfter={
          <>
            {isEmailValidationLoading && (
              <div className={styles.iconLoader}>
                <PrimaryLoader
                  text="Verifying"
                  borderWidth={1}
                  mode="segment"
                  size={12}
                />
              </div>
            )}
            {(!isEmailValidationLoading && ((emailValue || defaultValue) && !error && emailStatus)) && (
              <div className={styles.iconTick}><Tick /></div>
            )}
          </>
        }
        {...rest}
      />
    </>
  )
}

export default EmailField;
